import ApiModel from './globals/ApiModel';

export default class UserMeModel extends ApiModel {
  static get path() {
    return '/backend/users/{id}/me';
  }
}
